module.exports = __webpack_public_path__ + "img/task-content-logo.64609d34.png";